<template>
 <transition name="el-zoom-in-center">
   <div class="axj-tool" >
     <div class="axj-tool-top" @click="top">
       <el-icon name="caret-top"></el-icon>
     </div>
     <div class="axj-tool-pre" @click="pre">
       <el-icon name="caret-top"></el-icon>
     </div>
     <div class="axj-tool-next" @click="next">
       <el-icon name="caret-top"></el-icon>
     </div>
   </div>
 </transition>
</template>

<script>
export default {
  name: "axj-tool",
  methods:{
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true);
    },
    handleScroll () {
      // document.querySelector('.axj-main').scroll()
      // if(document.querySelector('.axj-main').scrollTop==0){
      //   this.axjToolShow=false
      // }else{
      //   this.axjToolShow=true
      // }
    },
    pre(){
      this.$emit('pre')
    },
    next(){
      this.$emit('next')
    },
    top(){
      let docu=document
      let timeId
      if(document.querySelector('.axj-main').scrollTop!=0){
        timeId=setTimeout(res=>{
          docu.querySelector('.axj-main').scrollTop=docu.querySelector('.axj-main').scrollTop-10
          this.top()
        },5)
      }else{
        clearTimeout(timeId)
      }
      console.log('ok')
    }
  },
  created () {
    this.listenerFunction();
  },
  beforeDestroy () {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  data(){
    return{
      axjToolShow:false
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-tool{
  position: absolute;
  width: 150px;
  height: 150px;
  bottom: 0;
  right: 40px;
  z-index: 1;
  div:hover{
    background-color: #e1e3e3;
  }
  div{
    cursor: pointer;
    position: absolute;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #f2f5f6;
    box-shadow: 0 0 6px rgba(0,0,0, .12);
    text-align: center;
    line-height: 40px;
    color: #00adb5;
    display: flex;
    justify-content: center;
    align-items: center;
    i{
      margin-top: -5px;
      font-size: 26px;
    }
  }
  .axj-tool-top{
    right: 55px;
    top: 50px;
  }
  .axj-tool-pre{
    right: 105px;
    top: 65px;
    transform:rotate(-90deg);
    -ms-transform:rotate(-90deg); 	/*!* IE 9 *!*/
    -moz-transform:rotate(-90deg); 	/*!* Firefox *!*/
    -webkit-transform:rotate(-90deg); /*!* Safari 和 Chrome *!*/
    -o-transform:rotate(-90deg);
  }
  .axj-tool-next{
    top: 65px;
    right: 5px;
    transform:rotate(90deg);
    -ms-transform:rotate(90deg); 	/*!* IE 9 *!*/
    -moz-transform:rotate(90deg); 	/*!* Firefox *!*/
    -webkit-transform:rotate(90deg); /*!* Safari 和 Chrome *!*/
    -o-transform:rotate(90deg);
  }
}
/*.left{*/
/*  transform:rotate(-90deg);*/
/*  -ms-transform:rotate(-90deg); 	!* IE 9 *!*/
/*  -moz-transform:rotate(-90deg); 	!* Firefox *!*/
/*  -webkit-transform:rotate(-90deg); !* Safari 和 Chrome *!*/
/*  -o-transform:rotate(-90deg);*/
/*}*/
/*.rigth{*/
/*  transform:rotate(90deg);*/
/*  -ms-transform:rotate(90deg); 	!* IE 9 *!*/
/*  -moz-transform:rotate(90deg); 	!* Firefox *!*/
/*  -webkit-transform:rotate(90deg); !* Safari 和 Chrome *!*/
/*  -o-transform:rotate(90deg);*/

/*}*/
</style>



// WEBPACK FOOTER //
// src/views/axj-main/component/axj-tool/index.vue